import { render, staticRenderFns } from "./spirit-bottle-1-labeled.vue?vue&type=template&id=f2bbcd18"
import script from "./spirit-bottle-1-labeled.vue?vue&type=script&lang=js"
export * from "./spirit-bottle-1-labeled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports